import tw from "twin.macro";
import { CircularProgress } from "@mui/material";

const CircularProgressMidScreen = tw(CircularProgress)`fixed left-1/2 top-1/2 transform[translate(-50%, -50%)]`;

export default CircularProgressMidScreen;
